// extracted by mini-css-extract-plugin
module.exports = {"menubar":"MenuBar_menubar__3lW26","menuItem":"MenuBar_menuItem__3VONA","activeMenuItem":"MenuBar_activeMenuItem__2IKbg"};